export const normalizeEventDate = (value) => {
  if (!value) return null;
  const parsed = new Date(value);
  if (Number.isNaN(parsed.getTime())) return null;
  return parsed;
};

export const sortEventsByStart = (events = []) => {
  return [...events].sort((a, b) => {
    const aTime = normalizeEventDate(a.eventStartDate || a.eventDate)?.getTime() || 0;
    const bTime = normalizeEventDate(b.eventStartDate || b.eventDate)?.getTime() || 0;
    return aTime - bTime;
  });
};

export const formatEventWindow = (startValue, endValue) => {
  const format = (value) => {
    if (!value) return '';
    const parsed = new Date(value);
    if (Number.isNaN(parsed.getTime())) return value;
    return parsed.toLocaleString();
  };

  const startLabel = format(startValue);
  const endLabel = format(endValue);

  if (startLabel && endLabel) return `${startLabel} to ${endLabel}`;
  return startLabel || endLabel || 'Schedule to be confirmed';
};

export const splitEventsByTimeline = (events = []) => {
  const now = Date.now();
  const sorted = sortEventsByStart(events);

  return sorted.reduce(
    (groups, event) => {
      const startTime = normalizeEventDate(event.eventStartDate || event.eventDate)?.getTime() || 0;
      if (startTime >= now) {
        groups.upcoming.push(event);
      } else {
        groups.past.push(event);
      }
      return groups;
    },
    { upcoming: [], past: [] }
  );
};
